// CLOUDWEB-19713
// Фейкдор "Поиск и организация пространства для файлов в Облаке"

import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import {
    IS_B2B_BIZ_USER,
    IS_CORP_USER,
    IS_DOCUMENTS_DOMAIN,
    IS_MY_TEAM,
    IS_PAID_USER,
    IS_PHONE_BROWSER,
} from 'reactApp/appHelpers/configHelpers';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';

const DISABLE_FEATURE = IS_PHONE_BROWSER || IS_B2B_BIZ_USER || IS_PAID_USER || IS_CORP_USER || IS_DOCUMENTS_DOMAIN || IS_MY_TEAM;

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_POPUP_ID = 'ai-organize-fakedoor';
/** Ключ для локалстораджа от попапа */
export const storageKeyForPopup = `${PROMO_POPUP_ID}`;
export const aiOrganizePromoFakedoorVariant: undefined | 'a' | 'b' | 'c' | 'd' = getFeature(`ai-organize-fakedoor-variant`);
export const isCVariantAiOrganizeFakedoor = aiOrganizePromoFakedoorVariant === 'c';

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showInterval: number = +getFeature(`${PROMO_POPUP_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeLimit: number = +getFeature(`${PROMO_POPUP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showLimit: number = +getFeature(`${PROMO_POPUP_ID}-show-limit`) || 3;

/** id промо - для включения нужно будет включать фичу 3promo-enable-{id} */
export const PROMO_BANNER_ID = 'ai-organize-banner-fakedoor';
/** Ключ для локалстораджа от баннера */
export const storageKeyForBanner = `${PROMO_BANNER_ID}`;

/** Временной промежуток между показами одной и той же промки, в секундах */
export const showBannerInterval: number = +getFeature(`${PROMO_BANNER_ID}-show-interval`) || 172800;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeBannerLimit: number = +getFeature(`${PROMO_BANNER_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showBannerLimit: number = +getFeature(`${PROMO_BANNER_ID}-show-limit`) || 3;

export const videoUrlAiOrganize = `${cdnPackagesUrl}/static/cloud/promo/aiOrganizeFakedoor/aiOrganize.mp4`;

export const fileTypesForAiOrganize: string[] = getFeature('ai-organize-file-types') || ['pdf', 'docx', 'xlsx', 'pptx'];

// CLOUDWEB-19872 Фейкдор "Поиск и организация пространства для файлов в Облаке" ч.2
export const enableStarsAiOrganizeIconInDatalist =
    !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-icon');

export const PROMO_STARS_TIP_ID = 'ai-organize-stars-tip';
/** Временной промежуток между показами одной и той же промки, в секундах */
export const showTipInterval: number = +getFeature(`${PROMO_STARS_TIP_ID}-show-interval`) || 86400;
/** Максимальное количество закрытий промки (на крестик в баннере / на primary кнопку) */
export const closeTipLimit: number = +getFeature(`${PROMO_STARS_TIP_ID}-close-limit`) || 3;
/** Максимальное количество показов, в которых не взаимодействуют с промкой */
export const showTipLimit: number = +getFeature(`${PROMO_STARS_TIP_ID}-show-limit`) || 3;

export const isAiOrganizeTipOnStars = isFeature('ai-organize-stars-tip-enabled');

// CLOUDWEB-19892 Фейкдор "Поиск и организация пространства для файлов в Облаке" ч.3
export const isAiOrganizeSearchButton = !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-search');
export const isAiOrganizeSearchButtonTooltip =
    !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-search-tip-enabled');
export const isAiOrganizeSortButton = !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-sort');
export const isAiOrganizeSortButtonTooltip =
    !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-sort-tip-enabled');
export const isAiOrganizeMultiSortButton =
    !DISABLE_FEATURE && aiOrganizePromoFakedoorVariant === 'd' && isFeature('ai-organize-multi-sort');
